var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.promoBannerClasses,style:(_vm.promoBannerStyles),attrs:{"data-contentful-text":_vm.promoBanner.CmsBanner.Id}},[_vm._v("\n  "+_vm._s(_vm.promoBanner.CmsBanner.Text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444dc738","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/shared/components/PromoBanner.vue
// module id = 528
// module chunks = 0 2 5 6 8